import type { FaireProductEntity } from "../../entity_types/product";

export const p_uz73va6fa5: FaireProductEntity = {
  token: "p_uz73va6fa5",
  type: "product",
  name: "White Daisy Flower Charms, 16x13mm",
  brandToken: "b_dzynp8b3sq",
  brandName: "Guerrilla Charm",
  imageUrl:
    "https://cdn.faire.com/fastly/88ba7a946e45fa93e9d0465f6b2b77d7fc15dffb4da04934d9f767c8d7847364.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c439f862c79e9a1e3f15ecaf59f7d1f02d28736fac55cb046e0535b7a037f11.jpeg",
    "https://cdn.faire.com/fastly/6e43f919283bcc360e7517478bf43db985445823f447e8f79a8fb14253c65a88.jpeg",
    "https://cdn.faire.com/fastly/3f5b6c2a066c8816e0bc3bda889da0ddcb0ca0600e6799524157405ea1f3d86c.jpeg",
  ],
  priceDollars: 2.4,
  description:
    "These cute little charms are sure to bring joy and beauty to your creations. Available in 1, 4, 20 or 50 pieces.\n\n-16x13x1.5 mm\n-2 mm hole\n-Zinc alloy with enamel fill\n\nContains small parts. Not intended for children.\n",
  tags: [],
  msrpDollars: 3,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:26.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
